import {
  Component,
  ContentChildren,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  QueryList
} from '@angular/core';

import { WizardStepComponent, WizardTitleComponent } from '../wizard-modal/wizard-modal.component';

@Component({
  selector: 'app-wizard-inline',
  templateUrl: './wizard-inline.component.html',
  styleUrls: ['./wizard-inline.component.scss']
})
export class WizardInlineComponent {
  @HostBinding('class.vertical') @Input() vertical = false;
  @Input() concludesInDelete = false;
  @Input() canDelete = false;
  @Input() hasDelete = true;
  @Input() canDeleteTooltipText: string;
  @Input() isLoading = false;
  @Input() isEditMode = false;
  @Input() isViewMode = false;
  @Input() isReadOnlyMode = false;

  @Output() stepChange = new EventEmitter<number>();
  @Output() stepErrorsChange = new EventEmitter<void>();
  @Output() submit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();

  @ContentChildren(WizardStepComponent) steps!: QueryList<WizardStepComponent>;

  stepList: WizardStepComponent[] = [];
  activeStepIndex = 0;

  ngAfterContentInit(): void {
    this.stepList = this.steps.toArray();
    this.steps.changes.subscribe(() => {
      this.stepList = this.steps.toArray();
    });

    if (this.activeStep) {
      this.activeStep.isActive = true;
    }
  }

  next(): void {
    this.activeStep.nextTriggered = true;
    if (!this.activeStep.canContinue) {
      this.stepErrorsChange.emit();
      return;
    }
    this.activeStep.isActive = false;
    this.activeStepIndex++;
    this.propagateStepChange();
  }

  prev(): void {
    this.activeStepIndex--;
    this.propagateStepChange();
  }

  skipStep(): void {
    this.next();
  }

  finalSubmit(): void {
    this.submit.emit();
  }

  onDelete(): void {
    this.delete.emit();
  }

  reset(): void {
    this.activeStepIndex = 0;
    this.steps.forEach(step => step.reset());
  }

  isStepActive(index: number): boolean {
    return index === this.activeStepIndex;
  }

  isStepComplete(index: number): boolean {
    return index < this.activeStepIndex;
  }

  propagateStepChange(): void {
    this.activeStep.isActive = true;
    this.stepChange.emit(this.activeStepIndex);
  }

  get activeStep(): WizardStepComponent {
    return this.stepList[this.activeStepIndex];
  }

  get isLastStep(): boolean {
    return this.activeStepIndex === this.stepList.length - 1;
  }

  get isFirstStep(): boolean {
    return this.activeStepIndex === 0;
  }

  get nextDisabled(): boolean {
    return this.activeStep.nextTriggered ? !this.activeStep.canContinue : false;
  }

  get canSkipStep(): boolean {
    return this.activeStep.canSkip;
  }

  get canStepSave(): boolean {
    return this.activeStep.canSave;
  }

  get isSaveDisabled(): boolean {
    return this.activeStep.saveDisabled;
  }

  get isStepAfterSubmit(): boolean {
    return this.activeStep.isAfterSubmit;
  }
}
